import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function RealPainSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-white relative border-t border-brand-gold/10" data-id="element-402" data-mp="3btbmy20l9dr5">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-403" data-mp="3gsefwo3antir">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6
      }} data-id="element-404" data-mp="3gqv357guk0lq">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-405" data-mp="2t2tulyjo4k6b">
            {t('testimonials.title')}
          </h2>
          <div className="w-16 h-1 bg-brand-gold mb-8" data-id="element-406" data-mp="2x58feo6wdu08"></div>

          <div className="space-y-6 text-lg text-brand-charcoal" data-id="element-407" data-mp="2j4xpbndewjg4">
            <p className="font-medium" data-id="element-408" data-mp="2j6qwd3rxt5on">{t('testimonials.p1')}</p>
            <p className="text-xl font-serif text-brand-gold-light italic" data-id="element-409" data-mp="2o2phmihyy7ku">
              {t('testimonials.highlight')}
            </p>
            <p data-id="element-410" data-mp="1zwc3k1najc01">{t('testimonials.p2')}</p>
            <p data-id="element-411" data-mp="1uvo5wx4k3wwu">{t('testimonials.p3')}</p>
            <p className="font-medium" data-id="element-412" data-mp="1uuv4mbod9zm3">{t('testimonials.p4')}</p>
            <p data-id="element-413" data-mp="28v5xfk98lo9w">{t('testimonials.p5')}</p>
          </div>
        </motion.div>
      </div>
    </section>;
}